export default function DashboardPanel({
  title,
  description,
  badge,
  children,
  className = "",
  bodyClassName = "p-5",
  noPadding = false,
}) {
  return (
    <section
      className={`overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm ${className}`}
    >
      {title || description || badge ? (
        <div className="border-b border-slate-100 bg-gradient-to-r from-slate-50 to-white px-5 py-4">
          <div className="flex items-start justify-between gap-3">
            <div>
              {title ? (
                <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
              ) : null}
              {description ? (
                <p className="mt-1 text-xs leading-relaxed text-slate-500">
                  {description}
                </p>
              ) : null}
            </div>
            {badge ? <div className="shrink-0">{badge}</div> : null}
          </div>
        </div>
      ) : null}
      <div className={noPadding ? bodyClassName : bodyClassName}>{children}</div>
    </section>
  );
}
